// extracted by mini-css-extract-plugin
module.exports = {"container":"BH","disclaimerIcon":"BI","content":"BJ","timeToBeginWatchingText":"BK"};